// prettier-ignore
const customRoutes = [
  {
    path: "/logs",
    name: "logs",
    meta: {
      isGnb: true,
      containerTitle: "로그기록",
    },
    components: {
      header: () => import("../components/organisms/dashboard-header/DashboardHeaderComponent.vue"),
      content: () => import("../pages/custom/logs/LogsPage.vue"), 
    },
  },
  {
    path: "/traffic",
    name: "traffic",
    meta: {
      isGnb: true,
      containerTitle: "트래픽사용량",
    },
    components: {
      header: () => import("../components/organisms/dashboard-header/DashboardHeaderComponent.vue"),
      content: () => import("../pages/custom/traffic/TrafficPage.vue"),
    },
  },
];

export default customRoutes;
